const Container = {
	baseStyle: {
		maxW: "container.xl",
		paddingX: { xl: "2rem", base: "1rem" },
	},
};

export default Container;
